import { useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

export default function MappingCompatibilityHelp() {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Button
        icon="pi pi-question-circle"
        className="p-button-text p-button-sm"
        onClick={() => setVisible(true)}
        tooltip="View mapping compatibility"
      />
      <Dialog
        header="Field Type Mapping Reference"
        visible={visible}
        onHide={() => setVisible(false)}
        style={{ width: "600px" }}
      >
        <p className="text-500 mb-3">
          Use this reference to select the correct field type for each Tally
          question.
        </p>
        <table className="w-full">
          <thead>
            <tr className="border-bottom-1 surface-border">
              <th className="text-left p-2">Tally Question Type</th>
              <th className="text-left p-2">Compatible Field Types</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="p-2">
                Multiple Choice, Checkboxes, Multi Select, Checkbox
              </td>
              <td className="p-2">List, String</td>
            </tr>
            <tr>
              <td className="p-2">Input Text</td>
              <td className="p-2">String, Text, List</td>
            </tr>
            <tr>
              <td className="p-2">
                Email, Phone, Input Email, Input Phone Number, Input Link
              </td>
              <td className="p-2">String, Text, Group</td>
            </tr>
            <tr>
              <td className="p-2">Textarea</td>
              <td className="p-2">Text</td>
            </tr>
            <tr>
              <td className="p-2">
                Number, Rating, Input Number, Ranking Option
              </td>
              <td className="p-2">Number, Number with Decimals</td>
            </tr>
            <tr>
              <td className="p-2">Date, Input Date</td>
              <td className="p-2">Date</td>
            </tr>
            <tr>
              <td className="p-2">Dropdown, Input Time, Dropdown Option</td>
              <td className="p-2">String, Reference, List</td>
            </tr>
            <tr>
              <td className="p-2">File Upload</td>
              <td className="p-2">Video, Image</td>
            </tr>
          </tbody>
        </table>
      </Dialog>
    </>
  );
}
